import { Link } from "@tanstack/react-router";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

export interface BreadcrumbEntry {
  label: string;
  to: string;
  params?: Record<string, string>;
  search?: Record<string, unknown>;
}

interface NavBreadcrumbsProps {
  items: BreadcrumbEntry[];
  current: string;
}

export function NavBreadcrumbs({ items, current }: NavBreadcrumbsProps) {
  return (
    <Breadcrumb>
      <BreadcrumbList>
        {items.map((item, i) => [
          <BreadcrumbItem key={`item-${item.to}-${item.label}-${i}`}>
            <BreadcrumbLink asChild>
              <Link
                to={item.to}
                params={item.params ?? {}}
                search={(item.search ?? {}) as any}
              >
                {item.label}
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>,
          <BreadcrumbSeparator key={`separator-${item.to}-${item.label}-${i}`} />,
        ])}
        <BreadcrumbItem>
          <BreadcrumbPage>{current}</BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
}
